(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zenfaden-motion"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('zf-motion')){customElements.define('zf-motion',class extends HTMLElement{connectedCallback(){if(this.bound)return;this.bound=true;const button=this.querySelector('button');button.addEventListener('click',()=>{const paused=this.classList.toggle('is-paused');button.setAttribute('aria-pressed',String(paused));button.querySelector('[data-pause]').hidden=paused;button.querySelector('[data-play]').hidden=!paused;});}});}

  } catch(e) { console.error(e); }
})();
})();
